import { render, staticRenderFns } from "./Supportick.vue?vue&type=template&id=04a68bda&"
import script from "./Supportick.vue?vue&type=script&lang=js&"
export * from "./Supportick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports